// src/game/lighting/brazierLightingConfig.js

// Master toggle for brazier light contributing to visibility / darkness protection.
// Keep this ON for current behavior. Later we can route "lit/unlit" state through here.
export const BRAZIER_LIGHTING_ENABLED = true;

// Base brazier light radius (Manhattan distance).
// Was effectively 1 in App.js. Set to 2 to increase by +1.
export const BRAZIER_LIGHT_RADIUS_BASE = 3;

// Optional future hook (keep for readability / easy scaling later).
export const BRAZIER_LIGHT_RADIUS_BONUS = 0;

// Final radius used by the game right now.
export const BRAZIER_LIGHT_RADIUS = Math.max(
  0,
  BRAZIER_LIGHT_RADIUS_BASE + BRAZIER_LIGHT_RADIUS_BONUS
);